<template>
  <div :class="[
    'bold font-8',
    $vuetify.theme.dark ? 'white--text' : ''
  ]"
    style="margin-bottom: 8px !important; color: --var(text) ;"
  >
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'VLabel',
  props: {
    text: {
      type: String,
      required: true,
      default: 'label',
    },
  },
};
</script>

<style>
</style>
